import React from 'react';
import PropTypes from 'prop-types';

import { FaCheckCircle, FaExclamationTriangle } from 'react-icons/fa';
import { Container } from './styles';

function StatusWarningInfo({ status, labelTrue, labelFalse }) {
  return (
    <Container>
      {status ? <FaCheckCircle color="#00d318" size={20} /> : <FaExclamationTriangle color="#ffc107" size={20} />}
      {status ? labelTrue : labelFalse}
    </Container>
  );
}

StatusWarningInfo.propTypes = {
  status: PropTypes.bool.isRequired,
  labelTrue: PropTypes.string.isRequired,
  labelFalse: PropTypes.string.isRequired,
};

export default StatusWarningInfo;
